import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Droplets, Loader2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { adminLogin, setToken, LOGO_URL } from '../../lib/api';
import { useToast } from '../../hooks/use-toast';

export default function AdminLogin() {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await adminLogin(password);
      setToken(data.access_token);
      toast({ title: 'Connecté', description: 'Bienvenue dans l\'administration.' });
      navigate('/admin');
    } catch (err) {
      toast({ title: 'Accès refusé', description: 'Mot de passe incorrect.', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 via-white to-emerald-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Logo" className="w-20 h-20 rounded-full mx-auto shadow-lg mb-4" />
          <h1 className="font-display font-extrabold text-3xl text-sky-950">Espace admin</h1>
          <p className="text-sm text-slate-500 mt-2">Kiosques à Eau — CMS</p>
        </div>
        <div className="bg-white rounded-3xl shadow-xl border border-sky-100 p-8">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label className="text-xs font-semibold uppercase tracking-wider text-slate-600">Mot de passe</Label>
              <div className="relative mt-2">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <Input
                  type="password"
                  required
                  autoFocus
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="pl-11 h-12 rounded-xl border-sky-200"
                />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full h-12 bg-gradient-to-r from-sky-500 to-emerald-500 hover:from-sky-600 hover:to-emerald-600 text-white font-bold rounded-xl border-0">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Se connecter'}
            </Button>
          </form>
        </div>
        <p className="text-center text-xs text-slate-400 mt-6">← <a href="/" className="hover:text-sky-700">Retour au site</a></p>
      </div>
    </div>
  );
}
